const configCaheItems = [
  {
    title: 'Propiedades de categoría',
    function: 'cr_prptpl',
  },
  {
    title: 'Estado',
    function: 'crs',
  },
  {
    title: 'Impacto',
    function: 'imp',
  },
  {
    title: 'Prioridad',
    function: 'pri',
  },
  {
    title: 'Acceso funcional',
    function: 'func_access_role',
  },
  {
    title: 'Ubicación',
    function: 'loc',
  },
  {
    title: 'Categoría',
    function: 'pcat',
  },
  {
    title: 'Familia del recurso',
    function: 'nrf',
  },
  {
    title: 'Clase del recurso',
    function: 'grc',
  },
  {
    title: 'Estado del recurso',
    function: 'rss',
  },
  {
    title: 'Tipo de reclamación',
    function: 'ztipo_reclamacion',
  },
  {
    title: 'Método de creación',
    function: 'intfc',
  },
  {
    title: 'Aprobadores',
    function: 'zapproval_workflow_tpl',
  },
  {
    title: 'Flujo de aprobación',
    function: 'zelement_site_appwftpl',
  },
  {
    title: 'Síntoma',
    function: 'zsintoma_comun',
  },
  {
    title: 'Ubicación Pteis',
    function: 'zubicacion_pteis',
  },
  {
    title: 'Grupos de contacto',
    function: 'grpmen',
  },
  {
    title: 'Tratamiento especial',
    function: 'contact_handling',
  },
  {
    title: 'Relaciones entre recursos',
    function: 'bmhier',
  },
  {
    title: 'Tipo de contacto',
    function: 'ctp',
  },
  {
    title: 'Tipo de actividad',
    function: 'aty',
  },
  {
    title: 'Plantilla de encuesta',
    function: 'svy_tpl',
  },
  {
    title: 'Plantilla de pregunta',
    function: 'svy_qtpl',
  },
  {
    title: 'Plantilla de respuesta',
    function: 'svy_atpl',
  },
  {
    title: 'Check de bienvenida',
    function: 'property/display_welcome_news',
  },
];
export { configCaheItems as default };
